import { NgModule } from '@angular/core';
import { E5peterExampleLibComponent } from './e5peter-example-lib.component';

@NgModule({
  imports: [
  ],
  declarations: [E5peterExampleLibComponent],
  exports: [E5peterExampleLibComponent]
})
export class E5peterExampleLibModule { }
